import React, { useEffect, useRef, useState } from 'react';
import { storageImage } from '../../../../lib/img';

const STORAGE_KEY = 'episode_taste_profile';

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return { text: '', stylesEnabled: true };
}
function save(state) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch {}
}

export default function TasteModal({ open, onClose, user, profile }) {
  const [state, setState] = useState(load);
  const [saved, setSaved] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function onKey(e) { if (e.key === 'Escape') onClose?.(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const initials = (profile?.full_name?.[0] || user?.email?.[0] || '?').toUpperCase();
  const charCount = state.text.length;
  const MAX = 2000;

  function handleSave() {
    save(state);
    setSaved(true);
    setTimeout(() => setSaved(false), 1800);
  }

  return (
    <div className="v4-taste-wrap" role="dialog" aria-modal="true" aria-label="My Taste">
      <div className="v4-taste-backdrop" onClick={onClose} />
      <div className="v4-taste" ref={ref}>
        <button className="v4-taste-close" onClick={onClose} aria-label="Close">✕</button>

        <div className="v4-taste-head">
          <span className="v4-taste-avatar">
            {profile?.avatar_url
              ? <img src={storageImage(profile.avatar_url, { width: 96 })} alt="" />
              : <span>{initials}</span>}
          </span>
          <div>
            <div className="v4-taste-title">My Taste</div>
            <div className="v4-taste-sub">
              Capture your taste profile on Epio. The more you create, like and dislike, the more
              Epio learns to speak your podcast language.
            </div>
            <div className="v4-taste-sub" style={{ marginTop: 6 }}>
              Or write one now to shape your sound right away.
            </div>
          </div>
        </div>

        <textarea
          className="v4-taste-ta"
          placeholder={`Core topic: The arc of emotionally intelligent masculinity for men 25–40.
Tone: Direct, warm, no therapy-speak. Clear frameworks over vibes.
Structure: 3-turn hooks. Personal story → uncomfortable truth → payoff.
Length: 35–55 minutes. Short-form cuts optimized for Reels and Shorts.
References: Huberman (structure), Mark Manson (voice), Chris Williamson (pacing).
Avoid: hustle tropes, manosphere clichés, unsourced claims.`}
          value={state.text}
          onChange={e => setState(s => ({ ...s, text: e.target.value.slice(0, MAX) }))}
        />
        <div className="v4-taste-count">{charCount} / {MAX}</div>

        <div className="v4-taste-toggle-row">
          <div>
            <div className="v4-taste-toggle-label">My Podcast Styles</div>
            <div className="v4-taste-toggle-sub">
              When toggled on, using the magic wand in the description field will apply your taste profile
              to generate episode style suggestions.
            </div>
          </div>
          <button
            className={`v4-taste-toggle${state.stylesEnabled ? ' on' : ''}`}
            onClick={() => setState(s => ({ ...s, stylesEnabled: !s.stylesEnabled }))}
            aria-pressed={state.stylesEnabled}
          >
            <span className="v4-taste-toggle-knob" />
          </button>
        </div>

        <div className="v4-taste-actions">
          <button className="v4-taste-save" onClick={handleSave}>
            {saved ? 'Saved ✓' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
}
